import { Locale } from '../../types'
import { LocaleListSkeleton } from '../common/Skeleton'
import LocaleCard from './LocaleCard'

interface LocaleListProps {
  locali: Locale[]
  loading?: boolean
  favoriti?: number[]
  onFavoritoClick?: (localeId: number) => void
}

/**
 * Griglia responsiva di LocaleCard
 */
export default function LocaleList({
  locali,
  loading = false,
  favoriti = [],
  onFavoritoClick,
}: LocaleListProps) {
  // Mostra skeleton durante il caricamento
  if (loading) {
    return <LocaleListSkeleton count={6} />
  }

  // Messaggio se nessun locale
  if (locali.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 mx-auto mb-4 bg-gray-800 rounded-full flex items-center justify-center">
          <svg
            className="w-8 h-8 text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
            />
          </svg>
        </div>
        <h3 className="text-xl font-display text-white mb-2">
          Nessun locale trovato
        </h3>
        <p className="text-gray-400">
          Prova a modificare i filtri di ricerca
        </p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {locali.map((locale) => (
        <LocaleCard
          key={locale.id}
          locale={locale}
          isFavorito={favoriti.includes(locale.id)}
          onFavoritoClick={onFavoritoClick}
        />
      ))}
    </div>
  )
}
